import { CatalogGrid } from "./Catalog";
import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import Searchresult from "./search";
import Api_key from "./apiconfiguration";
import LoadingScreen from "./LoadingScreen";

const Upcoming = ({ search }) => {
  const [upcomingMovies, setUpcomingMovies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiKey = Api_key;

  useEffect(() => {
    const fetchUpcomingMovies = async () => {
      try {
        const upcomingEndpoint = `https://api.themoviedb.org/3/movie/upcoming?language=en-US&api_key=${apiKey}`;

        const responses = await Promise.all([
          axios.get(`${upcomingEndpoint}&page=1`),
          axios.get(`${upcomingEndpoint}&page=2`),
          axios.get(`${upcomingEndpoint}&page=3`),
          axios.get(`${upcomingEndpoint}&page=4`),
          axios.get(`${upcomingEndpoint}&page=5`),
          axios.get(`${upcomingEndpoint}&page=6`),
          axios.get(`${upcomingEndpoint}&page=7`),
          axios.get(`${upcomingEndpoint}&page=8`),
        ]);

        const combinedMovies = responses.flatMap(response => response.data.results);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const filteredMovies = combinedMovies.filter(movie => {
          const releaseDate = new Date(movie.release_date);
          return releaseDate > today;
        });

        setUpcomingMovies(filteredMovies.slice(0, 120));
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchUpcomingMovies();
  }, []);


  if (error) return <p>Error loading upcoming movies: {error}</p>;
  if (loading) return <LoadingScreen label="Looking beyond the marquee" />;

  return (
    <>
      {search ? (
        <Searchresult search={search} />
      ) : (
        <CatalogGrid items={upcomingMovies.slice(0, 60)} title="Worth the wait." description="A first look at the stories coming your way." eyebrow="COMING SOON" />
      )}
    </>
  );
};

export default Upcoming;
